import { FormGroup, Select } from '@ksyos/design-system';
import { useEffect } from 'react';
import type { HolterGradingData } from '@common/validation/customControls/cardiology/holter/holterGradingSchemas';
import type { HolterExaminationRequestBase } from '@common/validation/customControls/cardiology/holter/utils/utils';
import {
    HolterConclusionOption,
    HolterGradingAdvice,
    holterGradingAdviceOptions,
} from '@common/validation/customControls/cardiology/holter/utils/gradingAndConsultUtils';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { getValidationErrorTranslation, useProcessActivityEditContext } from '@frontend/utils';

export function HolterGradingAdviceSelect() {
    const { data, errors } = useProcessActivityEditContext<HolterGradingData>();
    const { onChange } = useEditFormSectionInputFieldContext<HolterExaminationRequestBase>();
    const holterGradingAdviceOptionsIfConclusionIsAlarmerend = holterGradingAdviceOptions.filter((advice) =>
        [
            HolterGradingAdvice.verwijzing_polikliniek_cardiologie,
            HolterGradingAdvice.spoed_verwijs_patient_naar_eerste_harthulp,
        ].includes(advice)
    );
    const holterGradingAdviceOptionsifConclusionisAnythingElse = holterGradingAdviceOptions.filter(
        (advice) => ![HolterGradingAdvice.spoed_verwijs_patient_naar_eerste_harthulp].includes(advice)
    );

    useEffect(() => {
        if (
            data?.conclusion !== HolterConclusionOption.alarmerend_afwijkend &&
            data?.advice === HolterGradingAdvice.spoed_verwijs_patient_naar_eerste_harthulp
        ) {
            onChange([]);
        }

        if (data?.conclusion === HolterConclusionOption.alarmerend_afwijkend && Array.isArray(data?.advice)) {
            onChange(null);
        }
    }, [data?.conclusion, data?.advice]);

    if (data?.conclusion === HolterConclusionOption.alarmerend_afwijkend) {
        return (
            <FormGroup
                isRequired
                label="Advies"
            >
                <Select
                    error={getValidationErrorTranslation(errors.get('advice'))}
                    onChange={(advice) => advice && onChange(advice.value)}
                    options={holterGradingAdviceOptionsIfConclusionIsAlarmerend.map((value) => ({
                        label: value,
                        value,
                    }))}
                    placeholder=""
                    value={data.advice ? { label: data.advice, value: data.advice } : null}
                />
            </FormGroup>
        );
    } else {
        return (
            <FormGroup
                isRequired
                label="Advies"
            >
                <Select
                    error={getValidationErrorTranslation(errors.get('advice'))}
                    isMulti
                    onChange={(advices) => advices && onChange(advices.map((advice) => advice.value))}
                    options={holterGradingAdviceOptionsifConclusionisAnythingElse.map((value) => ({
                        label: value,
                        value,
                    }))}
                    placeholder=""
                    value={
                        data.advice && Array.isArray(data.advice)
                            ? holterGradingAdviceOptionsifConclusionisAnythingElse
                                  .filter((advice) => data.advice?.includes(advice))
                                  .map((advice) => ({
                                      label: advice,
                                      value: advice,
                                  }))
                            : null
                    }
                />
            </FormGroup>
        );
    }
}
